/* ============================================================
   LIV-OUTDOORS PRODUCT PAGE JS
   Asset: assets/lo-product.js
   
   Handles:
   - Variant selection (color/size/config buttons)
   - Add-on checkbox price calculation
   - Live "Your Build" price breakdown
   - Gallery thumbnail switching + hover zoom + lightbox
   - Tab navigation
   - Quantity selector
   - AJAX add-to-cart (triggers nav's cart drawer)
   
   NOTE: Does NOT create a cart drawer. The nav JS (liv-outdoors-nav.js)
   owns the cart drawer. This script just adds to cart via AJAX
   and tells the nav drawer to open.
   ============================================================ */

(function() {
  'use strict';

  // ── Load product JSON ──
  var jsonEl = document.getElementById('lo-product-json');
  if (!jsonEl) return;
  var product = JSON.parse(jsonEl.textContent);
  var variants = product.variants;

  // Track current option selections
  var currentOptions = [];
  if (variants.length > 0) {
    currentOptions = variants[0].options ? variants[0].options.slice() : [];
  }

  // ── VARIANT SELECTION ──
  window.loSelectOption = function(btn) {
    var index = parseInt(btn.dataset.optionIndex);
    var value = btn.dataset.value;

    var parent = btn.parentElement;
    parent.querySelectorAll('.lo-color-opt, .lo-size-opt').forEach(function(b) {
      b.classList.remove('lo-color-opt--active', 'lo-size-opt--active');
    });
    if (btn.classList.contains('lo-color-opt')) {
      btn.classList.add('lo-color-opt--active');
    } else {
      btn.classList.add('lo-size-opt--active');
    }

    var valEl = document.getElementById('loOptVal-' + index);
    if (valEl) valEl.textContent = '— ' + value;

    currentOptions[index] = value;
    var matchedVariant = findVariant(currentOptions);

    if (matchedVariant) {
      var select = document.getElementById('loVariantSelect');
      if (select) select.value = matchedVariant.id;
      loRecalcPrice();
    }
  };

  function findVariant(options) {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return opt === options[i];
      });
    });
  }

  // ── PRICE CALCULATOR ──
  window.loRecalcPrice = function() {
    var select = document.getElementById('loVariantSelect');
    var selectedOption = select.options[select.selectedIndex];
    var basePrice = parseInt(selectedOption.dataset.price) || 0;

    var lines = [];
    lines.push({ label: 'Base Price', val: basePrice });
    var total = basePrice;

    document.querySelectorAll('.lo-addon-check input:checked').forEach(function(cb) {
      var upcharge = parseInt(cb.dataset.upcharge) || 0;
      var label = cb.dataset.label || 'Add-on';
      lines.push({ label: label, val: upcharge });
      total += upcharge;
    });

    function fmt(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
    }

    var livePriceEl = document.getElementById('loLivePrice');
    var atcPriceEl = document.getElementById('loAtcPrice');
    if (livePriceEl) livePriceEl.textContent = fmt(total);
    if (atcPriceEl) atcPriceEl.textContent = fmt(total);

    var breakdown = document.getElementById('loPriceBreakdown');
    var linesEl = document.getElementById('loBreakdownLines');
    var totalEl = document.getElementById('loBreakdownTotal');

    if (lines.length > 1 && breakdown) {
      breakdown.style.display = 'block';
      linesEl.innerHTML = lines.map(function(l) {
        return '<div class="lo-breakdown-line"><span>' + l.label + '</span><span class="lo-bl-val">' + fmt(l.val) + '</span></div>';
      }).join('');
      if (totalEl) totalEl.textContent = fmt(total);
    } else if (breakdown) {
      breakdown.style.display = 'none';
    }
  };

  // ── QUANTITY ──
  window.loChangeQty = function(delta) {
    var input = document.getElementById('loQtyVal');
    if (!input) return;
    var val = parseInt(input.value) + delta;
    if (val < 1) val = 1;
    if (val > 99) val = 99;
    input.value = val;
  };

  // ── GALLERY THUMBNAIL SWITCH ──
  window.loSwitchImage = function(thumb, imgUrl) {
    document.querySelectorAll('.lo-thumb').forEach(function(t) {
      t.classList.remove('lo-thumb--active');
    });
    thumb.classList.add('lo-thumb--active');

    var mainImg = document.getElementById('loMainImage');
    if (mainImg) {
      mainImg.src = imgUrl;
    }
  };

  // ── HOVER-TO-ZOOM ──
  (function initZoom() {
    var gallery = document.getElementById('loGalleryMain');
    var img = document.getElementById('loMainImage');
    if (!gallery || !img) return;

    gallery.addEventListener('mouseenter', function() {
      gallery.classList.add('lo-zoom-active');
    });

    gallery.addEventListener('mouseleave', function() {
      gallery.classList.remove('lo-zoom-active');
      img.style.transform = '';
      img.style.transformOrigin = '';
    });

    gallery.addEventListener('mousemove', function(e) {
      if (!gallery.classList.contains('lo-zoom-active')) return;
      var rect = gallery.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2)';
    });
  })();

  // ── LIGHTBOX ──
  (function initLightbox() {
    var gallery = document.getElementById('loGalleryMain');
    var img = document.getElementById('loMainImage');
    if (!gallery || !img) return;

    var overlay = document.createElement('div');
    overlay.className = 'lo-lightbox';
    overlay.innerHTML = '<div class="lo-lightbox__backdrop"></div>' +
      '<div class="lo-lightbox__content">' +
      '<button class="lo-lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="lo-lightbox__prev" type="button" aria-label="Previous">&lsaquo;</button>' +
      '<img class="lo-lightbox__img" src="" alt="" />' +
      '<button class="lo-lightbox__next" type="button" aria-label="Next">&rsaquo;</button>' +
      '<div class="lo-lightbox__counter"></div>' +
      '</div>';
    document.body.appendChild(overlay);

    var lbImg = overlay.querySelector('.lo-lightbox__img');
    var lbClose = overlay.querySelector('.lo-lightbox__close');
    var lbPrev = overlay.querySelector('.lo-lightbox__prev');
    var lbNext = overlay.querySelector('.lo-lightbox__next');
    var lbCounter = overlay.querySelector('.lo-lightbox__counter');
    var lbBackdrop = overlay.querySelector('.lo-lightbox__backdrop');
    var currentIndex = 0;
    var isOpen = false;

    function getImages() {
      var imgs = [];
      document.querySelectorAll('.lo-thumb img').forEach(function(t) {
        var src = t.src.replace(/width=\d+/, 'width=1200');
        imgs.push(src);
      });
      if (imgs.length === 0 && img.src) {
        imgs.push(img.src);
      }
      return imgs;
    }

    function openLightbox(index) {
      var images = getImages();
      if (images.length === 0) return;
      currentIndex = index || 0;
      lbImg.src = images[currentIndex];
      lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
      overlay.classList.add('lo-lightbox--open');
      document.body.style.overflow = 'hidden';
      isOpen = true;
    }

    function closeLightbox() {
      overlay.classList.remove('lo-lightbox--open');
      document.body.style.overflow = '';
      isOpen = false;
    }

    function navigate(dir) {
      var images = getImages();
      if (images.length === 0) return;
      currentIndex = (currentIndex + dir + images.length) % images.length;
      lbImg.src = images[currentIndex];
      lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
    }

    gallery.addEventListener('click', function(e) {
      if (isOpen) return;
      e.preventDefault();
      e.stopPropagation();
      var activeThumbs = document.querySelectorAll('.lo-thumb');
      var idx = 0;
      activeThumbs.forEach(function(t, i) {
        if (t.classList.contains('lo-thumb--active')) idx = i;
      });
      openLightbox(idx);
    });

    lbClose.addEventListener('click', function(e) { e.stopPropagation(); closeLightbox(); });
    lbBackdrop.addEventListener('click', function(e) { e.stopPropagation(); closeLightbox(); });
    lbPrev.addEventListener('click', function(e) { e.stopPropagation(); navigate(-1); });
    lbNext.addEventListener('click', function(e) { e.stopPropagation(); navigate(1); });
    lbImg.addEventListener('click', function(e) { e.stopPropagation(); });

    document.addEventListener('keydown', function(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });
  })();

  // ── TABS ──
  window.loShowTab = function(idx) {
    var tabs = document.querySelectorAll('.lo-pdp-tab-content');
    tabs.forEach(function(tab) {
      tab.classList.remove('lo-pdp-tab-content--active');
    });
    var target = document.getElementById('lo-tab-' + idx);
    if (target) target.classList.add('lo-pdp-tab-content--active');
    document.querySelectorAll('.lo-pdp-tab-btn').forEach(function(btn, i) {
      btn.classList.toggle('lo-pdp-tab-btn--active', i === idx);
    });
  };

  // ── AJAX ADD TO CART (product page only) ──
  // Adds main product + any checked add-ons as separate cart items with real prices.
  // Cart rendering, quantity, remove are handled globally by lo-cart-ajax.js
  (function initAjaxCart() {
    var form = document.getElementById('lo-product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var atcBtn = form.querySelector('.lo-atc-btn');
      var originalText = atcBtn.innerHTML;

      atcBtn.disabled = true;
      atcBtn.innerHTML = '<span style="letter-spacing:1px;">Adding...</span>';

      // Build items array: main product + checked add-ons
      var select = document.getElementById('loVariantSelect');
      var qty = document.getElementById('loQtyVal');
      var mainVariantId = select ? select.value : null;
      var mainQty = qty ? parseInt(qty.value) || 1 : 1;

      if (!mainVariantId) {
        atcBtn.disabled = false;
        atcBtn.innerHTML = originalText;
        return;
      }

      var items = [];

      // Get main product title for grouping
      var mainTitle = document.querySelector('.lo-pdp-title');
      var mainTitleText = mainTitle ? mainTitle.textContent.trim() : 'Product';

      // Main product
      items.push({
        id: parseInt(mainVariantId),
        quantity: mainQty,
        properties: { '_is_main': 'true' }
      });

      // Checked add-ons (each is a separate product with its own variant ID)
      document.querySelectorAll('.lo-addon-check input:checked').forEach(function(cb) {
        var addonVariantId = cb.dataset.addonVariant;
        if (addonVariantId) {
          items.push({
            id: parseInt(addonVariantId),
            quantity: mainQty,
            properties: { '_addon_for': mainTitleText }
          });
        }
      });

      // Add all items at once using Shopify's batch endpoint
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        atcBtn.innerHTML = '<span style="letter-spacing:1px;">&#10003; Added!</span>';
        atcBtn.style.background = '#5A8F6A';

        // Use global function from lo-cart-ajax.js
        if (typeof window.loRefreshAndOpenCart === 'function') {
          window.loRefreshAndOpenCart();
        }

        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.style.background = '';
          atcBtn.innerHTML = originalText;
        }, 2500);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        atcBtn.innerHTML = '<span style="letter-spacing:1px;">Error — Try Again</span>';
        atcBtn.style.background = '#C75050';
        setTimeout(function() {
          atcBtn.disabled = false;
          atcBtn.style.background = '';
          atcBtn.innerHTML = originalText;
        }, 2000);
      });
    });
  })();

})();